import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";

import { ROUTES } from "@/constants/routes.constants";

import { Button, LogoIcon } from "@/components/base";

export const NotFound: React.FC = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  return (
    <div className="flex h-full w-full grow flex-col items-center justify-center gap-5 align-middle">
      <LogoIcon className="size-[70px]" />

      <span className="text-page-title text-text">
        {t("404: Seems like you're lost. Let's get you back on track.")}
      </span>

      <Button
        onClick={() => {
          window.history.replaceState({}, "", ROUTES.HOME);
          navigate(ROUTES.HOME);
        }}
      >
        {t("Go Home")}
      </Button>
    </div>
  );
};
